import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
const samplePurchases = [{
  name: 'Danielle M.',
  location: 'Austin, TX, USA'
}, {
  name: 'Natalie R.',
  location: 'Denver, CO, USA'
}, {
  name: 'Megan S.',
  location: 'San Diego, CA, USA'
}, {
  name: 'Ashley T.',
  location: 'Tampa, FL, USA'
}, {
  name: 'Jennifer L.',
  location: 'Phoenix, AZ, USA'
}, {
  name: 'Rachel B.',
  location: 'Columbus, OH, USA'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(samplePurchases[0]);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(samplePurchases[Math.floor(Math.random() * samplePurchases.length)]);
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);
  return visible ? <aside className="fixed bottom-3 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[260px] animate-slide-in" aria-live="polite" data-id="element-189" data-mp="1sq3j3kjq2cty">
      <div className="relative overflow-hidden rounded-xl border-2 border-brand-navy bg-brand-mint p-3 pr-8 shadow-2xl ring-2 ring-brand-gold/60" data-id="element-190" data-mp="2qcj5n0r0a0od">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-blue" data-id="element-191" data-mp="2lcodktvhv51q" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1.5 top-1.5 rounded p-0.5 text-brand-slate transition-colors hover:text-brand-ink" aria-label="Dismiss purchase notification" data-id="element-192" data-mp="2gdtlt2fju65h">
          <XIcon className="h-3.5 w-3.5" data-id="element-193" data-mp="10yeaee08r33b" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-194" data-mp="1110iqfuyhmml">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-gold/60 bg-brand-gold/15" data-id="element-195" data-mp="12gustrpj45ck">
            <ShoppingBagIcon className="h-4 w-4 text-brand-navy" data-id="element-196" data-mp="17ctl3qdza7i9" />
          </div>
          <div className="min-w-0 leading-tight" data-id="element-197" data-mp="sh3ufexul677">
            <p className="text-sm font-extrabold text-brand-ink" data-id="element-198" data-mp="xgglkbvr4zfl">{current.name}</p>
            <p className="text-[11px] font-semibold text-brand-slate" data-id="element-199" data-mp="jpbptkvi8raj">from {current.location}</p>
            <p className="mt-0.5 text-xs font-bold text-brand-blue" data-id="element-200" data-mp="og1uevw3wq46">just purchased {PRODUCT_NAME}</p>
          </div>
        </div>
      </div>
    </aside> : null;
}